import React from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from 'components/Icon'
import messages from './messages'
import styles from './MapLegends.scss'

interface MapLegendsProps {
  legends?: string[]
}

const MapLegends: React.FC<MapLegendsProps> = ({ legends }) => (
  <ul className={styles.list}>
    {legends &&
      legends.map(key => (
        <li key={key} className={styles.item}>
          <Icon size='regular' name={`indicator-${key}`}>
            <FormattedMessage {...messages.legends[key]} />
          </Icon>
        </li>
      ))}
  </ul>
)

export default MapLegends

